import { render, staticRenderFns } from "./LoginOverlay.vue?vue&type=template&id=2c4d628d&scoped=true"
import script from "./LoginOverlay.vue?vue&type=script&lang=ts"
export * from "./LoginOverlay.vue?vue&type=script&lang=ts"
import style0 from "./LoginOverlay.vue?vue&type=style&index=0&id=2c4d628d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4d628d",
  null
  
)

export default component.exports